const HomeBackground = () => {
    return ( 
        <div className="home-bg"></div>
     );
}
 
export default HomeBackground;